import Axios from 'axios';
import { jwtExpired } from '~/utils/catcher';

export const axios = Axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/',
});

axios.interceptors.response.use((res) => res, jwtExpired);
